__turbopack_context__.v({
  "capability": "styles-module__qTku3G__capability",
  "content": "styles-module__qTku3G__content",
  "heading": "styles-module__qTku3G__heading",
  "imageWrapper": "styles-module__qTku3G__imageWrapper",
  "textContent": "styles-module__qTku3G__textContent",
  "textTitles": "styles-module__qTku3G__textTitles",
  "textWrapper": "styles-module__qTku3G__textWrapper",
  "titles": "styles-module__qTku3G__titles",
  "underrline": "styles-module__qTku3G__underrline",
  "wrapper": "styles-module__qTku3G__wrapper",
});
